/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
// import PropTypes from 'prop-types';

import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import s from './Home.css';
// import StockSearchBar from '../../components/StockSearchBar/StockSearchBar';

const GET_STOCKS = gql`
  {
    stock {
      code
      chineseName
      englishName
    }
  }
`;

export default function Home() {
  useStyles(s);

  const { loading, error, data } = useQuery(GET_STOCKS);
  if (loading) return 'Loading...';
  if (error) return `Error! ${error.message}`;

  const { stock } = data;

  return (
    <div className={s.root}>
      <div className={s.container}>
        {/* <StockSearchBar /> */}
        <h1>ABC Charts</h1>
        {stock.map((item) => (
          <article key={item.code} className={s.newsItem}>
            <h1 className={s.newsTitle}>
              <a href={`/stock/${item.code}`}>
                {item.code} {item.chineseName} {item.englishName}
              </a>
            </h1>
          </article>
        ))}
      </div>
    </div>
  );
}

// Home.propTypes = {
//   news: PropTypes.arrayOf(
//     PropTypes.shape({
//       title: PropTypes.string.isRequired,
//       link: PropTypes.string.isRequired,
//       content: PropTypes.string,
//     }),
//   ).isRequired,
// };
